var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71875 33.75C7.71875 35.0938 8 35.75 10.1875 36.2188C10.1875 36.2188 10.7812 36.3125 11.6562 36.4688L12.4375 32.1875L11.6562 28.0312C9.34375 28.9062 7.71875 31.125 7.71875 33.75Z",
    fill: "url(#paint0_linear_536_2960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3438 28.0312L27.5625 32.25L28.3438 36.4688C29.25 36.3125 29.8125 36.2188 29.8125 36.2188C32 35.75 32.2813 35.125 32.2813 33.75C32.2813 31.125 30.6563 28.9062 28.3438 28.0312Z",
    fill: "url(#paint1_linear_536_2960)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4062 37.1875C25.1562 36.9687 27.0625 36.6562 28.3437 36.4375V28C27.6562 27.75 26.9062 27.5938 26.125 27.5938H13.8437C13.0625 27.5938 12.3125 27.75 11.625 28V36.4375C12.9062 36.6562 14.8125 36.9375 16.5625 37.1875L20 37.5L23.4062 37.1875Z",
    fill: "url(#paint2_linear_536_2960)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 25V28.375C16.3125 30.4063 17.9687 32.0625 20 32.0625C22.0312 32.0625 23.6875 30.4063 23.6875 28.375V25.0312L16.3125 25Z",
    fill: "url(#paint3_linear_536_2960)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2191 12.1272C32.7816 12.1272 31.2191 3.37721 26.0003 5.28346C25.0628 2.75221 21.7191 2.18971 19.9691 4.28346C18.2191 2.18971 14.9066 2.78346 13.9378 5.28346C8.75033 3.40846 7.18783 12.1272 12.7191 12.1272H27.2191Z",
    fill: "url(#paint4_radial_536_2960)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1251 12.125C11.6251 12.9687 11.4376 13.7812 11.4376 14.0937C8.12505 14.0937 8.06255 19.1563 11.4376 19.2813C11.7501 21.8438 13.2501 27.25 20.0001 27.25C26.7501 27.25 28.2501 21.8438 28.5626 19.2813C31.9688 19.1563 31.6876 14.0937 28.5626 14.0937C28.5626 13.7812 28.3438 12.9062 27.8126 12.0312L12.1251 12.125Z",
    fill: "url(#paint5_radial_536_2960)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint6_linear_536_2960)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint7_linear_536_2960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_2960",
    x1: 10.0735,
    y1: 36.4575,
    x2: 10.0735,
    y2: 28.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0844235,
    stopColor: "#D6775C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#E28F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#EBA081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#F0AA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AD8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_2960",
    x1: 29.9265,
    y1: 36.4575,
    x2: 29.9265,
    y2: 28.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0844235,
    stopColor: "#D6775C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#E28F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#EBA081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#F0AA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AD8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_2960",
    x1: 20,
    y1: 37.1968,
    x2: 20,
    y2: 27.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_2960",
    x1: 20,
    y1: 32.074,
    x2: 20,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1849,
    stopColor: "#EEA788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#E49779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#D47D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9497,
    stopColor: "#BF5C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_536_2960",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3163 4.00589) scale(21.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5425,
    stopColor: "#383B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292B2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_536_2960",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.42924 11.782) scale(22.4795 22.4795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#F1AB8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6503,
    stopColor: "#EDA485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7805,
    stopColor: "#E7987A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#DE876B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9771,
    stopColor: "#D37157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_536_2960",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_536_2960",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4c27e5679549feeec1479c48962ee807.svg";
export { ForwardRef as ReactComponent };